
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mathmagic/donate",
      function () {
        return require("private-next-pages/mathmagic/donate/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mathmagic/donate"])
      });
    }
  